import styled from '@emotion/styled';
import { Row as BaseRow } from '../../../../../../ui';

export const Row = styled(BaseRow)``;

Row.defaultProps = {
	columns: 1,
};
